var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20960"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.201 2.47516C13.201 3.83925 12.0899 4.95032 10.7258 4.95032H6.87555C6.19351 4.95032 5.57747 4.6753 5.12644 4.22428C4.67541 3.77325 4.40039 3.15721 4.40039 2.47516C4.40039 1.11107 5.51146 0 6.87555 0H10.7258C11.4078 0 12.0239 0.275018 12.4749 0.726047C12.9259 1.17708 13.201 1.79312 13.201 2.47516Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3141 3.33194C16.061 3.12293 15.775 2.95792 15.467 2.83691C15.148 2.7159 14.829 2.96892 14.763 3.29894C14.3889 5.18006 12.7278 6.59916 10.7257 6.59916H6.87545C5.77538 6.59916 4.74131 6.17013 3.96026 5.38908C3.38822 4.81704 2.99219 4.09099 2.83818 3.30994C2.77218 2.97992 2.44216 2.7159 2.12314 2.84791C0.847055 3.36495 0 4.53102 0 6.87417V17.5998C0 20.9 1.96913 22.0001 4.40029 22.0001H13.2009C15.632 22.0001 17.6011 20.9 17.6011 17.5998V6.87417C17.6011 5.08106 17.1061 3.98099 16.3141 3.33194ZM4.40029 11.2744H8.80057C9.2516 11.2744 9.62563 11.6484 9.62563 12.0995C9.62563 12.5505 9.2516 12.9245 8.80057 12.9245H4.40029C3.94926 12.9245 3.57523 12.5505 3.57523 12.0995C3.57523 11.6484 3.94926 11.2744 4.40029 11.2744ZM13.2009 17.3248H4.40029C3.94926 17.3248 3.57523 16.9508 3.57523 16.4998C3.57523 16.0487 3.94926 15.6747 4.40029 15.6747H13.2009C13.6519 15.6747 14.0259 16.0487 14.0259 16.4998C14.0259 16.9508 13.6519 17.3248 13.2009 17.3248Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.7405b352a52d1b68064e55f8679019bb.svg";
export { ForwardRef as ReactComponent };